import { flow, Instance, types } from 'mobx-state-tree'
import { addPackage } from '../../network/addPackage'
import { deleteRoutingPackage } from '../../network/deleteRoutingPackage'
import { getAllPackageNames } from '../../network/getAllPackageNames'
import { getAllPackages } from '../../network/getAllPackages'
import { getPackageById } from '../../network/getPackageById'
import { packageProcessApprovals } from '../../network/packageProcessApprovals'
import { updatePackage } from '../../network/updatePackage'
import { getErrorMessage, MessageTypes } from '../../utils'
import { MDR_FEE_PACKAGE_FILETYPE } from '../../utils/constants'
import { RootStore } from '../store'

const FeePackage = types.model('FeePackage', {
  type: types.optional(types.literal('feePackage'), 'feePackage'),
  id: types.maybeNull(types.number),
  group: types.optional(types.string, ''),
  category: types.optional(types.string, ''),
  packageName: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
})

const FeePackageModel = types
  .model('PackageModel', {
    feePackage: types.optional(FeePackage, {}),
    feePackages: types.array(FeePackage),
    feePackageNames: types.array(types.string), // TODO:
  })
  .actions((self) => ({
    getAll: flow(function* getAll(data: any, paginationInfo: any) {
      try {
        const response = yield getAllPackages(data, paginationInfo, MDR_FEE_PACKAGE_FILETYPE)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getById: flow(function* getById(id: string) {
      try {
        const response = yield getPackageById(id, RootStore.session.getTokens)
        const own = self
        own.feePackage = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    add: flow(function* add(data: any) {
      try {
        const response = yield addPackage(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    update: flow(function* update(data: any) {
      try {
        const response = yield updatePackage(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    deletePackage: flow(function* deletePackage(data: any) {
      try {
        const response = yield deleteRoutingPackage(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield packageProcessApprovals(data, RootStore.session.getTokens, MDR_FEE_PACKAGE_FILETYPE)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    fetchPackageNames: flow(function* fetchPackageNames() {
      try {
        const response = yield getAllPackageNames(RootStore.session.getTokens, MDR_FEE_PACKAGE_FILETYPE)
        const own = self
        own.feePackageNames = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getPackageNames() {
      return self.feePackageNames.map((item, index) => ({
        id: index + 1,
        value: item,
      }))
    },
    getPackages() {
      return self.feePackages.map((item) => ({
        ...item,
        edit: 'edit',
        delete: 'delete',
      }))
    },
    getFilteredFeePackagesList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.feePackages ?? []
      const data = list?.map((item: any) => {
        return {
          ...item,
          edit: 'edit',
          delete: 'delete',
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return listData?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

const feePackageData = FeePackageModel.create({
  feePackage: {},
  feePackages: [],
  feePackageNames: [],
})

export type FeePackageModelType = Instance<typeof FeePackageModel>

export { FeePackage, feePackageData, FeePackageModel }
